import { motion } from "framer-motion";
import { PROCESS_STEPS } from "@/lib/site";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 sm:py-32 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <p className="tag-label mb-5">// Section 03 / Process</p>
            <h2 className="font-display text-4xl sm:text-5xl font-black tracking-tight text-white leading-[1.05]">
              From enquiry to <span className="text-[#FBBF24]">sign-off.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-neutral-400 text-base leading-relaxed">
              A four-step flow we run for every client — small or large, one-off or recurring.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/10">
          {PROCESS_STEPS.map((step, i) => (
            <motion.div
              key={step.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`process-step-${step.n}`}
              className="p-8 bg-[#0A0A0A] min-h-[220px] flex flex-col justify-between hover:bg-[#0E0E0E] transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#FBBF24]">
                  Step {step.n}
                </span>
                <span className="font-display text-5xl font-black text-white/10 leading-none">
                  {step.n}
                </span>
              </div>
              <div>
                <h3 className="font-display text-xl font-bold text-white">
                  {step.title}
                </h3>
                <p className="mt-3 text-sm text-neutral-400 leading-relaxed">
                  {step.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
